import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useTempParamStore = defineStore('tempParam', () => {
  // V2 API: { code: string; isUsed: boolean }
  const recoveryCode = ref<{ code: string; isUsed: boolean }[]>([])
  const setRecoveryCode = (rc: { code: string; isUsed: boolean }[]) => {
    if (rc) {
      recoveryCode.value = rc
    }
  }

  const clearRecoveryCode = () => {
    recoveryCode.value = []
  }

  const clearTempParams = () => {
    recoveryCode.value = []
  }

  return {
    setRecoveryCode,
    clearRecoveryCode,
    clearTempParams,
    recoveryCode,
  }
})
